import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import { Container, Typography, Link } from '@mui/material';

function Bibliotheque() {
  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '40px' }}>
      <NavigationBar />
          <Container maxWidth="lg" style={{ paddingTop: '60px' }}>
        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C' }}>
          Bibliothèque 
        </Typography>
        
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          La bibliothèque de l'Institut National de la Statistique du Burundi (INSBU) est une ressource précieuse permettant aux utilisateurs tant internes qu' externes à accéder aux informations sur les données statistiques essentielles.
        </Typography>
        
        <img src={`${process.env.PUBLIC_URL}/assets/Centre_à_guichet_unique1.jpg`} alt="image bibliothèque" style={{ maxWidth: '100%', marginBottom: '20px', borderRadius: '8px' }} />

        <Typography variant="h6" gutterBottom style={{ color: '#388E3C' }}>
          Nos Services
        </Typography>
        
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          Avec pour objectif principal de fournir des services de qualité, notre bibliothèque offre :
        </Typography>
        
        <ul style={{ paddingLeft: '20px', color: '#333' }}>
          <li>
            <strong>Accès libre à l'information :</strong> Offrir des données statistiques répondandant à la soif des utilisateurs, les institutions, organisations, chercheurs, étudiants, et entrepreneurs pour des décisions éclairées.
          </li>
          <li>
            <strong>Services gratuits :</strong> Accès aux informations est gratuit.
          </li>
          <li>
            <strong>Relation client :</strong> Nous  accueillons chaleureusement nos usagers et recueillons les suggestions sur leurs satisfactions.
          </li>
          <li>
            <strong>Documentation et archives :</strong> Maintenir des ressources documentaires à jour et accessibles.
          </li>
        </ul>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
           Nous accueillons  quotidiennement les utilisateurs des institutions, organisations, chercheurs, étudiants, consultants privés et entrepreneurs.
        </Typography>

        <Typography variant="h6" gutterBottom style={{ color: '#388E3C', marginTop: '20px' }}>
          Publications Disponibles
        </Typography>
        
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          Découvrez ci-dessous la liste des publications de la <strong>bibliothèque </strong>, disponibles en version électronique et sur support papier :
        </Typography>
        
        <ul style={{ paddingLeft: '20px', color: '#333' }}>
          <li>Rapports de l'Enquête intégrée sur les conditions de vie des ménages (EICVMB)</li>
          <li>Rapports des enquêtes démographiques et de santé (EDS)</li>
          <li>Annuaires statistiques</li>
          <li>La base de données des indicateurs du developpement humain durable (DHD)</li>
          <li>Les bulletins mensuels des prix</li>
          <li>Les bulletins trimestriels de conjoncture</li>
          <li>Les comptes nationaux</li>
          <li>L'indice des prix à la consommation</li>
          <li>L'indice des prix à la production agricole</li>
          <li>L'indice du coût de construction de logements neufs</li>
          <li>L'indice harmonisé à la production indistrielle</li>
          <li>L'indice du commerce extérieur</li>
          <li>L'indice du chiffre d'affaires</li>
          <li>Les bulletins du commerce extérieur</li>
          <li>Les bulletins de conjoncture</li>
          <li>La note de conjoncture</li>
          <li>Les référentiels (mercuriales) des prix au Burundi</li>
          <li>Rapports du Recensement Géneral de la Population et de l'Habitat (RGPH)</li>
        </ul>

        <Typography variant="h6" gutterBottom style={{ color: '#388E3C', marginTop: '20px' }}>
          Horaires d'Ouverture
        </Typography>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          Nos heures de service sont les suivantes (Heure d'Afrique centrale - UTC/GMT+02:00) :
          <br />
          <strong>Du lundi au vendredi : </strong> 7h30 à 15h30
          <br />
          <strong>Pause déjeuner : </strong> 12h30 à 13h00
        </Typography>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          Pour toute information supplémentaire, veuillez contacter <strong>Mr Gabriel CINYO</strong> à : 
          <Link href="mailto:gabcinyo@gmail.com" style={{ color: 'green', marginLeft: '5px' }}>
            gabcinyo@gmail.com
          </Link>.
        </Typography>
      </Container>
      <Footer />
    </div>
  );
}

export default Bibliotheque;